import { useState } from "react";
import styled from "styled-components";
import { getTranslate, getValue, prepareFormData } from "../contexts/Utils";
import Api from "../contexts/Api";
import { useNotification } from "./UseNotification";
import Formfields from './Formfields';

const ModalPrice = (props) => {
  const { data = {}, setModalData, lang, setMissions } = props;
  const { notification } = useNotification();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // 
  // ─── HANDLE SUBMIT PRICE HOURLY ───────────────────────────────────────
  //
  const handleSubmit = async (e) => {
    e.preventDefault();

    // loading is to prevent from multiple submit onClick
    if (loading) return;
    setLoading(true);

    // 
    // ─── SET PRICE HOURLY ───────────────────────────────────────
    //
    const formData = prepareFormData({ formId: 'form' });
    if (formData.errors) {
      setLoading(false);
      return setErrors(formData.errors)
    };

    let params = {
      data: { fields: { ...formData.fields, status: 3 }, mission_id: data.id },
      endpoint: '/missions',
      method: 'PUT'
    };

    const query = await Api(params);

    const message = query.success ? getTranslate('price_defined', lang) : query.message
    notification({ variant: query.success ? 'success' : 'error', message });

    if (query.success) {
      // close modal if success
      setModalData({});
      setLoading(false);

      // update missions list
      setMissions(prev => {
        let obj = { ...prev };
        obj[data.id].status = 3;
        obj[data.id].price = formData.fields.price;
        return obj;
      })
    }
  }

  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return Boolean(Object.keys(data).length) && <S.Container id="form">
    <h3>{getTranslate('set_price', lang)}</h3>
    <Formfields field={{ component: "text", type: 'number', name: "price", label: `${getTranslate('price', lang)} (€ HT)`, required: true, error: getValue(errors, ['price', 'message']) }} />
    <S.Button onClick={handleSubmit} type="submit" value={getTranslate('validate', lang)} />
  </S.Container>
}

export default ModalPrice;

// 
// ─── STYLE DEFINITION ───────────────────────────────────────
//
const S = {}
S.Container = styled.form`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  background: ${({ theme }) => theme.card};
  padding: 20px;
  z-index: 10;
  min-width: 400px;

  & *:not(.Mui-error, input[type="submit"]) {
    color: ${({ theme }) => theme.text} !important;
    border-color: ${({ theme }) => theme.text} !important;
  }
  & label.Mui-error {
    color: #d32f2f !important;
  }
  & div.Mui-error > input, div.Mui-error > textarea {
    border-color: #d32f2f !important;
  }

  & h3 {
    color: ${({ theme }) => theme.text};
    margin: 0;
    margin-bottom: 20px;
  }

  @media (max-width: 520px) {
    min-width: unset;
    width: 80%;
  }
`

S.Button = styled.input`
  background: ${({ theme }) => theme.linear};
  border: none;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  padding: 0 35px;
  height: 35px;
  min-height: 35px;
  box-sizing: border-box;
  border-radius: 5px;
  width: fit-content;
  margin-top: 30px;
  cursor: pointer;
  margin-left: auto;
`